export const QUOTE_AMOUNT_BROKERAGE_RATE_ERROR =
  "Brokerage rate must be equal or lower than";

export const errorWhiteList = [QUOTE_AMOUNT_BROKERAGE_RATE_ERROR];
